module.exports = __webpack_public_path__ + "static/media/helloimlaurie-IG-1.fd7d4b5a.PNG";